import script from "./ConfirmationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmationModal.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmationModal.vue?vue&type=style&index=0&id=79c33f42&lang=css"

const __exports__ = script;

export default __exports__